import React, {FunctionComponent} from "react";
import Input, {InputProps} from "./Input";

export type InputTextProps = Omit<InputProps<string>, "type">;

const InputText: FunctionComponent<InputTextProps> = ({value, onChange, small, cssClass, ...inputAttr}) => {
    return (
        <Input
            type="text"
            value={value}
            onChange={onChange}
            small={small}
            cssClass={cssClass}
            {...inputAttr}
        />
    );
};

export default InputText;
